export const SLICE = 'userManagement';

// getUserProfileInfo action types.
const GET_USER_PROFILE_INFO_ACTIONS = `${SLICE}/GET_USER_PROFILE_INFO_ACTIONS`;
export const GET_USER_PROFILE_INFO_ACTIONS_REQUEST = `${GET_USER_PROFILE_INFO_ACTIONS}/REQUEST`;
export const GET_USER_PROFILE_INFO_ACTIONS_SUCCESS = `${GET_USER_PROFILE_INFO_ACTIONS}/SUCCESS`;
export const GET_USER_PROFILE_INFO_ACTIONS_FAILURE = `${GET_USER_PROFILE_INFO_ACTIONS}/FAILURE`;

// updateUserProfileInfo action types.
export const UPDATE_USER_PROFILE_INFO_ACTION_TYPE = `${SLICE}/UPDATE_USER_PROFILE_INFO`;
export const UPDATE_USER_PROFILE_INFO_REQUEST = `${UPDATE_USER_PROFILE_INFO_ACTION_TYPE}_REQUEST`;
export const UPDATE_USER_PROFILE_INFO_SUCCESS = `${UPDATE_USER_PROFILE_INFO_ACTION_TYPE}_SUCCESS`;
export const UPDATE_USER_PROFILE_INFO_FAILURE = `${UPDATE_USER_PROFILE_INFO_ACTION_TYPE}_FAILURE`;

// updateUserLocale action types.
export const UPDATE_USER_LOCALE_ACTION_TYPE = `${SLICE}/UPDATE_USER_LOCALE`;
export const UPDATE_USER_LOCALE_REQUEST = `${UPDATE_USER_LOCALE_ACTION_TYPE}_REQUEST`;
export const UPDATE_USER_LOCALE_SUCCESS = `${UPDATE_USER_LOCALE_ACTION_TYPE}_SUCCESS`;
export const UPDATE_USER_LOCALE_FAILURE = `${UPDATE_USER_LOCALE_ACTION_TYPE}_FAILURE`;

// accept Invitation
export const ACCEPT_INVITATION_ACTION_TYPE = `${SLICE}/ACCEPT_INVITATION`;
export const ACCEPT_INVITATION_REQUEST = `${ACCEPT_INVITATION_ACTION_TYPE}_REQUEST`;
export const ACCEPT_INVITATION_SUCCESS = `${ACCEPT_INVITATION_ACTION_TYPE}_SUCCESS`;
export const ACCEPT_INVITATION_FAILURE = `${ACCEPT_INVITATION_ACTION_TYPE}_FAILURE`;

// create invitation
export const CREATE_INVITATION_ACTION_TYPE = `${SLICE}/CREATE_INVITATION`;
export const CREATE_INVITATION_REQUEST = `${CREATE_INVITATION_ACTION_TYPE}_REQUEST`;
export const CREATE_INVITATION_SUCCESS = `${CREATE_INVITATION_ACTION_TYPE}_SUCCESS`;
export const CREATE_INVITATION_FAILURE = `${CREATE_INVITATION_ACTION_TYPE}_FAILURE`;
export const CREATE_INVITATION_SUCCESS_RESET = `${CREATE_INVITATION_ACTION_TYPE}_SUCCESS_RESET`;

// resend invitation
export const RESEND_INVITATION_ACTION_TYPE = `${SLICE}/RESEND_INVITATION`;
export const RESEND_INVITATION_REQUEST = `${RESEND_INVITATION_ACTION_TYPE}_REQUEST`;
export const RESEND_INVITATION_SUCCESS = `${RESEND_INVITATION_ACTION_TYPE}_SUCCESS`;
export const RESEND_INVITATION_FAILURE = `${RESEND_INVITATION_ACTION_TYPE}_FAILURE`;

// delete invitation
export const DELETE_INVITATION_ACTION_TYPE = `${SLICE}/DELETE_INVITATION`;
export const DELETE_INVITATION_REQUEST = `${DELETE_INVITATION_ACTION_TYPE}_REQUEST`;
export const DELETE_INVITATION_SUCCESS = `${DELETE_INVITATION_ACTION_TYPE}_SUCCESS`;
export const DELETE_INVITATION_FAILURE = `${DELETE_INVITATION_ACTION_TYPE}_FAILURE`;

// confirm invitation
export const CONFIRM_INVITATION_ACTION_TYPE = `${SLICE}/CONFIRM_INVITATION`;
export const CONFIRM_INVITATION_REQUEST = `${CONFIRM_INVITATION_ACTION_TYPE}_REQUEST`;
export const CONFIRM_INVITATION_SUCCESS = `${CONFIRM_INVITATION_ACTION_TYPE}_SUCCESS`;
export const CONFIRM_INVITATION_FAILURE = `${CONFIRM_INVITATION_ACTION_TYPE}_FAILURE`;

// getUsersForLogisticsParty
export const GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = `${SLICE}/GET_USERS_FOR_LOGISTICS_PARTY`;
export const GET_USERS_FOR_LOGISTICS_PARTY_REQUEST = `${GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_REQUEST`;
export const GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS = `${GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_SUCCESS`;
export const GET_USERS_FOR_LOGISTICS_PARTY_FAILURE = `${GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_FAILURE`;

// getInvitedUsersForLogisticsParty
export const GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = `${SLICE}/GET_INVITED_USERS_FOR_LOGISTICS_PARTY`;
export const GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST = `${GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_REQUEST`;
export const GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS = `${GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_SUCCESS`;
export const GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE = `${GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE}_FAILURE`;

// deactivateUser
export const DEACTIVATE_USER_ACTION_TYPE = `${SLICE}/DEACTIVATE_USER_ACTION_TYPE`;
export const DEACTIVATE_USER_REQUEST = `${DEACTIVATE_USER_ACTION_TYPE}_REQUEST`;
export const DEACTIVATE_USER_SUCCESS = `${DEACTIVATE_USER_ACTION_TYPE}_SUCCESS`;
export const DEACTIVATE_USER_FAILURE = `${DEACTIVATE_USER_ACTION_TYPE}_FAILURE`;

// getDeactivatedUsers
export const GET_DEACTIVATED_USERS_ACTION_TYPE = `${SLICE}/GET_DEACTIVATED_USES_ACTION_TYPE`;
export const GET_DEACTIVATED_USERS_REQUEST = `${GET_DEACTIVATED_USERS_ACTION_TYPE}_REQUEST`;
export const GET_DEACTIVATED_USERS_SUCCESS = `${GET_DEACTIVATED_USERS_ACTION_TYPE}_SUCCESS`;
export const GET_DEACTIVATED_USERS_FAILURE = `${GET_DEACTIVATED_USERS_ACTION_TYPE}_FAILURE`;

// fetchUserDetails
export const FETCH_USER_DETAILS = `${SLICE}/FETCH_USER_DETAILS`;
export const FETCH_USER_DETAILS_REQUEST = `${FETCH_USER_DETAILS}_REQUEST`;
export const FETCH_USER_DETAILS_SUCCESS = `${FETCH_USER_DETAILS}_SUCCESS`;
export const FETCH_USER_DETAILS_FAILURE = `${FETCH_USER_DETAILS}_FAILURE`;
